import { render } from "./PeopleEntry.vue?vue&type=template&id=9c0ea190&scoped=true"
import script from "./PeopleEntry.vue?vue&type=script&lang=js"
export * from "./PeopleEntry.vue?vue&type=script&lang=js"

import "./PeopleEntry.vue?vue&type=style&index=0&id=9c0ea190&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9c0ea190"

export default script